import { render, staticRenderFns } from "./StickyNote.vue?vue&type=template&id=784792c7&scoped=true&"
var script = {}
import style0 from "./StickyNote.vue?vue&type=style&index=0&id=784792c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784792c7",
  null
  
)

export default component.exports